import { render } from "./event-card.vue?vue&type=template&id=1aa8c470&scoped=true"
import script from "./event-card.vue?vue&type=script&lang=js"
export * from "./event-card.vue?vue&type=script&lang=js"

import "./event-card.vue?vue&type=style&index=0&id=1aa8c470&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-1aa8c470"]])

export default __exports__